import { WebComponent } from "@cervval.js/client-html5-core/src/components/webComponent";
import { H_100, W_100 } from "@cervval.js/client-html5-core/src/tools/cssClasses.tools";
import { configureNavigation, configureTheme, registerDefaultServices } from "@cervval.js/client-html5-spa";
import { CustomElement } from "@cervval.js/client-html5-spa/navigation";
import { getNavigationServiceConfiguration } from "../../pages/navigation.config";

@CustomElement({
    name: "imxr-app",
    template: require("./app.html"),
    elementCssClasses: [W_100, H_100]
})
export class AppIMXR extends WebComponent {

    constructor() {
        super();

        // Register services
        registerDefaultServices();

        // document.title is set with app display name in login page
    }

    /**
     * Called when component is added to the DOM for the first time
     */
    public override init(): void {

        // Configure the single page application navigation (and load a page)
        configureNavigation(getNavigationServiceConfiguration());
    }
}